import {gql} from '@apollo/client';
import {client} from '../../graphql/client';

// GraphQL查询定义
const GET_MESSAGE_TEMPLATE_GRAY_CONFIG = gql`
  query GetMessageTemplateGrayConfig {
    getMessageTemplateGrayConfig {
      grayType
      driverIds
      dspIds
      isEnabled
    }
  }
`;

interface MessageTemplateGrayConfigType {
  grayType: number;
  driverIds: number[]; // 确保这是number数组
  dspIds: number[];    // 确保这是number数组
  isEnabled: boolean;
}

interface GetMessageTemplateGrayConfigResponse {
  getMessageTemplateGrayConfig: MessageTemplateGrayConfigType;
}

// 检查是否开启灰度
export async function isSmsTemplateGrayEnabled(
  dspId: number,
  driverId: number
): Promise<boolean> {
  try {
    const {data: result} = await client.query<GetMessageTemplateGrayConfigResponse>({
        query: GET_MESSAGE_TEMPLATE_GRAY_CONFIG,
        fetchPolicy: 'network-only',
    });

    const config = result?.getMessageTemplateGrayConfig;

    // 如果没有灰度配置，默认关闭
    if (!config) {
        return false;
    }

    if (config.isEnabled) {
        return true;
    }

    // 确保ID比较时使用数字类型
    const numericDriverId = Number(driverId);
    const numericDspId = Number(dspId);

    if (config.grayType === 1) {
        // 确保driverIds中的元素也是数字类型
        return config.driverIds.map(id => Number(id)).includes(numericDriverId);
    } else {
        // 确保dspIds中的元素也是数字类型
        return config.dspIds.map(id => Number(id)).includes(numericDspId);
    }
  } catch (error) {
    console.error('Failed to check gray config:', error);
    // 出错时默认关闭功能
    return false;
  }
}